import React from "react";
import PropTypes from "prop-types";
import { Chart, IconButton } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { alpha, useTheme } from "@mui/material";
import { ChartCardContainer, ChartCardHeader, ChartRefreshIcon } from "./ChartStyles";

export const ClientOfferChart = ({ loadClientOfferChartData, clientOfferChartData }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const chartData = useMemo(
    () => ({
      labels: clientOfferChartData.labels.map(label => {
        const date = new Date(label);
        return t("DATE_FORMAT", { date: { value: date, format: "MMMM" } });
      }),
      data: clientOfferChartData.series
    }),
    [clientOfferChartData, t]
  );

  return (
    <ChartCardContainer>
      <Chart
        type="line"
        title={
          <ChartCardHeader>
            {t("Dashboard.NoOfClientsWithOffers")}
            <IconButton
              color="primary"
              size="tiny"
              variant="text"
              tooltip={t("Refresh")}
              onClick={loadClientOfferChartData}
            >
              <ChartRefreshIcon />
            </IconButton>
          </ChartCardHeader>
        }
        data={{
          labels: chartData.labels,
          datasets: [
            {
              data: chartData.data,
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.5),
              lineTension: 0.5
            }
          ]
        }}
        options={{
          plugins: {
            title: {
              display: false
            },
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                title: function () {
                  return this.dataPoints[0]?.label;
                },
                label: function () {
                  return `${t("Dashboard.ClientOffers")}: ` + t("NUMBER", { number: this.dataPoints[0]?.raw });
                }
              }
            }
          },
          scales: {
            x: {
              ticks: {
                minRotation: 20
              }
            }
          }
        }}
      />
    </ChartCardContainer>
  );
};

ClientOfferChart.propTypes = {
  loadClientOfferChartData: PropTypes.func,
  clientOfferChartData: PropTypes.object
};

export default ClientOfferChart;
